// window.jQuery = $;
// window.$ = $;
// var Isotope = require('isotope-layout');

// $(document).ready(function() {
import mediumZoom from 'medium-zoom';
import PhotoSwipeLightbox from 'photoswipe/lightbox';
import PhotoSwipe from 'photoswipe';

// Plugin
(function () {

    $(document).on('click', '.portfolio-item-ajax', function() {
        $('#portfolio-single-result').remove();

        let parent = $(this).parents('.portfolio-item');
        let id = $(this).parents('.portfolio-item');
        let href = $(this).attr('href');
        let row = $(this).parents('.row');
       
        let row_items_count = row.children().length;
        let item_index =  parent.index() + 1 ;

        if(row.hasClass('ajax-load-first-of-row')){
            first_of_item_line_index = 1 ;
        }

        //get current line
        let items_count_per_row = 4 ;
        let _offset = 200 ;
        if (window.matchMedia("(max-width: 767px)").matches) {
            items_count_per_row = 1 ;
            _offset = 30;
        }

        let item_line = Math.ceil(item_index / items_count_per_row) ;
        let first_of_item_line_index = 1 ;
        if(row.hasClass('ajax-load-first-of-row')){
            first_of_item_line_index = 1 ;
        }
        else{ 
            first_of_item_line_index = ((item_line - 1) * items_count_per_row) + 1 ;
            first_of_item_line_index = row_items_count > 4 && first_of_item_line_index < 5 ? 5 : first_of_item_line_index ; // SI l'item cliqué est sur la première ligne, alors le single vient après la 1ere ligne
        }
       
        let first_of_item_line = row.find('.portfolio-item').eq(first_of_item_line_index - 1) ;
      

       first_of_item_line.before(`<div id="portfolio-single-result" class="col-12 w-100"><div class="portfolio-single-result-inner"></div></div>`);
       
       $('#portfolio-single-result').prepend(`<button class="navbar-toggler single-closer" type="button" aria-controls="portfolio-single-result" aria-expanded="true" aria-label="Fermer">
       <i class="fa fa-lg fa-times"></i></button>`);

       $([document.documentElement, document.body]).animate({
            scrollTop: $('#portfolio-single-result').offset().top - _offset
        }, 100);


        $('#portfolio-single-result .portfolio-single-result-inner').load(`${href} > #portfolio-item-main`, function(){
            $('#portfolio-single-result').addClass('complete');
            if( agenceaportfolio.settings.gallery === 'mediumzoom') {
                mediumZoom('[data-zoomable]');
            }
            else if( agenceaportfolio.settings.gallery === 'photoswipe') { 
                const lightbox = new PhotoSwipeLightbox({
                    gallery: '#agencea-portfolio-gallery',
                    children: 'a',
                    pswpModule: PhotoSwipe
                  });
                  lightbox.init();
            }
            $('#portfolioCarousel').carousel('cycle');
           
        });

        // Fermeture click & press "escape"
        $(document).on('click', '.single-closer', function(){
            $('#portfolio-single-result').removeClass('complete').remove();
        });

        $(document).on('keydown', function(e) {
            if (e.key == "Escape") {
               $('#portfolio-single-result').removeClass('complete').remove();
            }
        });

        return false ;
    });

    if( agenceaportfolio.settings.gallery === 'mediumzoom') {
        mediumZoom('[data-zoomable]');
    }
    else if( agenceaportfolio.settings.gallery === 'photoswipe') { 
        const lightbox = new PhotoSwipeLightbox({
            gallery: '#agencea-portfolio-gallery',
            children: 'a',
            pswpModule: PhotoSwipe
          });
          lightbox.init();
    }


    if(document.querySelector('.grid')){
        var iso = new Isotope( '.grid', {
            itemSelector: '.portfolio-item',
            layoutMode: 'fitRows'
        });

        setTimeout(function(){iso.layout();}, 300);
    

   
        // filter functions
        var filterFns = {
            // show if number is greater than 50
            numberGreaterThan50: function( itemElem ) {
            var number = itemElem.querySelector('.number').textContent;
            return parseInt( number, 10 ) > 50;
            },
            // show if name ends with -ium
            ium: function( itemElem ) {
            var name = itemElem.querySelector('.name').textContent;
            return name.match( /ium$/ );
            }
        };
    
        // bind filter button click
        var filtersElem = document.querySelector('.filters-button-group');
        if( filtersElem !== null ) {
            filtersElem.addEventListener( 'click', function( event ) {
                // only work with buttons
                if ( !matchesSelector( event.target, 'button' ) ) {
                return;
                }
                var filterValue = event.target.getAttribute('data-filter');
                // use matching filter function
                filterValue = filterFns[ filterValue ] || filterValue;
                iso.arrange({ filter: filterValue });
            });
        }
    
        // change is-checked class on buttons
        var buttonGroups = document.querySelectorAll('.button-group');
        if( buttonGroups !== null ) {
            for ( var i=0, len = buttonGroups.length; i < len; i++ ) {
                var buttonGroup = buttonGroups[i];
                radioButtonGroup( buttonGroup );
            }
        }
        
        function radioButtonGroup( buttonGroup ) {
            buttonGroup.addEventListener( 'click', function( event ) {
            // only work with buttons
            if ( !matchesSelector( event.target, 'button' ) ) {
                return;
            }
            buttonGroup.querySelector('.active').classList.remove('active');
            event.target.classList.add('active');
            });
        }
        // let clickAllButton = () => {
        //     document.getElementById("filter-all").click(function(e){
        //         console.log(e)
        //     });
        //     console.log('click');
        // }
        // clickAllButton();
    }


    /**
 * demo.js
 * http://www.codrops.com
 *
 * Licensed under the MIT license.
 * http://www.opensource.org/licenses/mit-license.php
 * 
 * Copyright 2018, Codrops
 * http://www.codrops.com
 */
{
    const mapNumber = (X,A,B,C,D) => (X-A)*(D-C)/(B-A)+C;
    // from http://www.quirksmode.org/js/events_properties.html#position
	const getMousePos = (e) => {
        let posx = 0;
        let posy = 0;
		if (!e) e = window.event;
		if (e.pageX || e.pageY) {
            posx = e.pageX;
			posy = e.pageY;
		}
		else if (e.clientX || e.clientY) 	{
			posx = e.clientX + document.body.scrollLeft + document.documentElement.scrollLeft;
			posy = e.clientY + document.body.scrollTop + document.documentElement.scrollTop;
		}
        return { x : posx, y : posy }
    }
    // Generate a random float.
    const getRandomFloat = (min, max) => (Math.random() * (max - min) + min).toFixed(2);


    // Effect 3
    class HoverImgFx3 {
        constructor(el) {
            this.DOM = {el: el};
            this.DOM.reveal = document.createElement('div');
            this.DOM.reveal.className = 'hover-reveal';
            this.DOM.reveal.style.overflow = 'hidden';
            this.DOM.reveal.innerHTML = `<div class="hover-reveal__inner"><div class="hover-reveal__img" style="background-image:url(${this.DOM.el.dataset.img})"></div></div>`;
            this.DOM.el.appendChild(this.DOM.reveal);
            this.DOM.revealInner = this.DOM.reveal.querySelector('.hover-reveal__inner');
            this.DOM.revealInner.style.overflow = 'hidden';
            this.DOM.revealImg = this.DOM.revealInner.querySelector('.hover-reveal__img');
            charming(this.DOM.el);
            this.DOM.letters = [...this.DOM.el.querySelectorAll('span')];
            this.initEvents();
        }
        initEvents() {
            this.positionElement = (ev) => {
                const mousePos = getMousePos(ev);
                const docScrolls = {
                    left : document.body.scrollLeft + document.documentElement.scrollLeft, 
                    top : document.body.scrollTop + document.documentElement.scrollTop
                };
                // this.DOM.reveal.style.top = `${mousePos.y+20-docScrolls.top}px`;
                // this.DOM.reveal.style.top = this.DOM.reveal.scrollTop;
                // this.DOM.reveal.style.left = `${mousePos.x+20-docScrolls.left}px`;
            };
            this.mouseenterFn = (ev) => {
                this.positionElement(ev);
                this.showImage();
                this.animateLetters();
            };
            this.mousemoveFn = ev => requestAnimationFrame(() => {
                this.positionElement(ev);
            });
            this.mouseleaveFn = () => {
                this.hideImage();
            };
            
            this.DOM.el.addEventListener('mouseenter', this.mouseenterFn);
            this.DOM.el.addEventListener('mousemove', this.mousemoveFn);
            this.DOM.el.addEventListener('mouseleave', this.mouseleaveFn);
        }
        showImage() {
            TweenMax.killTweensOf(this.DOM.revealInner);
            TweenMax.killTweensOf(this.DOM.revealImg);

            this.tl = new TimelineMax({
                onStart: () => {
                    this.DOM.reveal.style.opacity = 1;
                    // TweenMax.set(this.DOM.el, {zIndex: 10});
                }
            })
            .add('begin')
            .set([this.DOM.revealInner, this.DOM.revealImg], {transformOrigin: '50% 100%'})
            .add(new TweenMax(this.DOM.revealInner, 0.4, {
                ease: Expo.easeOut,
                startAt: {x: '50%', y: '120%', rotation: 50},
                x: '0%',
                y: '0%',
                rotation: 0
            }), 'begin')
            .add(new TweenMax(this.DOM.revealImg, 0.4, {
                ease: Expo.easeOut,
                startAt: {x: '-50%', y: '-120%', rotation: -50},
                x: '0%',
                y: '0%',
                rotation: 0
            }), 'begin')
            .add(new TweenMax(this.DOM.revealImg, 0.7, {
                ease: Expo.easeOut,
                startAt: {scale: 2},
                scale: 1
            }), 'begin');
        }
        hideImage() {
            TweenMax.killTweensOf(this.DOM.revealInner);
            TweenMax.killTweensOf(this.DOM.revealImg);

            this.tl = new TimelineMax({
                onStart: () => {
                    // TweenMax.set(this.DOM.el, {zIndex: 10});
                },
                onComplete: () => {
                    // TweenMax.set(this.DOM.el, {zIndex: 10});
                    TweenMax.set(this.DOM.reveal, {opacity: 0});
                }
            })
            .add('begin')
            .add(new TweenMax(this.DOM.revealInner, 0.6, {
                ease: Expo.easeOut,
                y: '-120%',
                rotation: -5
            }), 'begin')
            .add(new TweenMax(this.DOM.revealImg, 0.6, {
                ease: Expo.easeOut,
                y: '120%',
                rotation: 5,
                scale: 1.2
            }), 'begin')
        }
        animateLetters() {
            TweenMax.killTweensOf(this.DOM.letters);
            TweenMax.set(this.DOM.letters, {opacity: 0});
            TweenMax.staggerTo(this.DOM.letters, 0.2, {
                ease: Expo.easeOut,
                startAt: {x: '100%'},
                x: '0%',
                opacity: 1
            }, 0.03);
        }
    }

    
    [...document.querySelectorAll('[data-fx="3"] > a, a[data-fx="3"]')].forEach(link => new HoverImgFx3(link));

    // // Demo purspose only: Preload all the images in the page..
    // const contentel = document.querySelector('.content');
    // [...document.querySelectorAll('.block__title, .block__link, .content__text-link')].forEach((el) => {
    //     const imgsArr = el.dataset.img.split(',');
    //     for (let i = 0, len = imgsArr.length; i <= len-1; ++i ) {
    //         const imgel = document.createElement('img');
    //         imgel.style.visibility = 'hidden';
    //         imgel.style.width = 0;
    //         imgel.src = imgsArr[i];
    //         imgel.className = 'preload';
    //         contentel.appendChild(imgel);
    //     }
    // });
    // imagesLoaded(document.querySelectorAll('.preload'), () => document.body.classList.remove('loading'));
}

    
})();